import { useNodeEnv } from '@zg-rentals/rental-manager-env';

export const useFeatureFlagConstants = () => {
  const nodeEnv = useNodeEnv();
  const ZG_ENABLE_GUEST_PAY_TEST_DATA =
    nodeEnv.originalServerSideRequestCookies['ZG_ENABLE_GUEST_PAY_TEST_DATA'] === 'true';

  return { ZG_ENABLE_GUEST_PAY_TEST_DATA };
};
